import { FormControl } from '@angular/forms';

export function requiredFileType(
  type1: string,
  type2?: string,
  type3?: string
) {
  return function (control: FormControl) {
    const file = control.value;
    if (file) {
      let extension = '';

      if (typeof file === 'string') {
        extension = file.split('.').pop().toLowerCase();
      } else {
        extension = file.name.split('.')[1].toLowerCase();
      }

      if (type3 != null) {
        if (
          type1.toLowerCase() !== extension.toLowerCase() &&
          type2.toLowerCase() !== extension.toLowerCase() &&
          type3.toLowerCase() !== extension.toLowerCase()
        ) {
          return {
            requiredFileType: true,
          };
        }
      } else if (type2 != null) {
        if (
          type1.toLowerCase() !== extension.toLowerCase() &&
          type2.toLowerCase() !== extension.toLowerCase()
        ) {
          return {
            requiredFileType: true,
          };
        }
      } else {
        if (type1.toLowerCase() !== extension.toLowerCase()) {
          return {
            requiredFileType: true,
          };
        }
      }

      return false;
    }

    return false;
  };
}

export function toFormData<T>(formValue: T) {
  const formData = new FormData();

  for (const key of Object.keys(formValue)) {
    const value = formValue[key];
    formData.append(key, value);
  }

  return formData;
}

export function parseToDate(seconds: number): string {
  const date = new Date(0);
  date.setSeconds(seconds);

  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const secs = date.getUTCSeconds();

  const duration = `${hours}h:${minutes}m:${secs}s`;
  return duration;
}

export interface ResponseStructure {
  responseCode: any;
  responseMessage: string;
  responseResult: any;
}

export const ResponseCode = {
  BAD_REQUEST: 'BAD_REQUEST',
  OK: 'OK',
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
};
